import "./sliderCards.scss";

import "swiper/css/bundle";
import Swiper from "swiper/bundle";

const sliderCards = () => {
  let allSliderCards = document.querySelectorAll(".slider-cards");

  if (!allSliderCards.length) return;

  allSliderCards.forEach((el, i) => {
    let pagination = el.querySelector(".swiper-pagination");
    let typePagination = "bullets";

    let args = {
      slidesPerView: 1,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 1.3,
        },
      },
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true,
        type: typePagination,
      },
      navigation: {
        nextEl: ".slider-cards__next",
        prevEl: ".slider-cards__prev",
      },
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        notificationClass: "swiper-notification",
      },
    };

    new Swiper(el.querySelector(".swiper-container"), args);
  });
};

export default sliderCards;
